module.exports = __webpack_public_path__ + "img/star_off.06402099.svg";